import React, { useEffect } from "react";
import classes from "./ProfileComponents.module.scss";
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";

const AddInfo = ({
  // onInputChangeHandler,
  // addInfo,
  isEditMode,
  onFormReset,
  shouldReset,
}) => {
  // const schema = yup.object().shape({
  //   addInfo: yup.string().default(addInfo),
  // });

  // const { register, reset } = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   reValidateMode: "onSubmit",
  //   values: {
  //     addInfo: addInfo,
  //   },
  // });
  const { t } = useTranslation();
  const {
    register,
    reset,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  return (
    <>
      <h3 className={classes.subtitle}>{t("Additional information")}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Additional legal or admin notes you’d like to communicate to your clients. This will be inserted on the bottom of the invoice. The display of this information on the invoice visualization can be enabled (default) or disabled upon request. Additionally, it is possible to enable its display on the generated PDF also. To request either option, please contact support at support@dddinvoices.com with the subject line Seller AdditionalInfo .")}</Tooltip>}>
          <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
        </OverlayTrigger>
      </h3>
      <div className={classes.container}>
        <fieldset className={classes["input-container"]} disabled={!isEditMode} style={{alignItems:"normal", width:"100%"}}>
          <label htmlFor="addInfo">{t("Additional Info")}</label>
          <textarea
            type="text"
            name="addInfo"
            id="addInfo"
            {...register("addInfo")}
            placeholder="Info"
            style={{width:"100%"}}
          />
        </fieldset>
      </div>
    </>
  );
};

export default AddInfo;
